export const COGNITO_NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED';
export const CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED =
  'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED';
